import { createReducer } from 'deox';
import { AssetsSocial, UserSocial, Paging } from '@/types';
import { fetchAssetSocialActions, fetchListUserSocialActions } from '@/redux/actions/service-directory/social';

export interface SocialState {
  assetsSocial?: AssetsSocial;
  listUserSocial: {
    data: UserSocial[];
    paging: Paging;
  };
}

const initialState: SocialState = {
  assetsSocial: undefined,
  listUserSocial: {
    data: [],
    paging: {
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
    },
  },
};

const serviceDirectorySocialReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchAssetSocialActions.success, (state, { payload }) => {
    return {
      ...state,
      assetsSocial: payload,
    };
  }),
  handleAction(fetchListUserSocialActions.success, (state, { payload }) => {
    return {
      ...state,
      listUserSocial: payload,
    };
  }),
]);

export default serviceDirectorySocialReducer;
